import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MainContainerStore } from "./main-container.store";
import { MainContainerSidebarDebug } from "./main-container-sidebar-debug";
import { MainContainerSidebarItem } from "./main-container-sidebar-item";
import { SidebarOpener } from "./main-container-sidebar-opener";
import { RouterLink } from "@angular/router";

@Component({
  selector: "layout-main-container-sidebar",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MainContainerSidebarDebug, MainContainerSidebarItem, SidebarOpener, RouterLink],
  template: `
    <div class="flex h-full grow flex-col justify-between">
      <div>
        <div class="mb-2 flex items-center justify-between py-4 mr-4.5">
          <a [routerLink]="'/'" class="ml-4">
            <img src="assets/SaLa-logo_neg.svg" alt="SALA Logo" class="w-36" />
          </a>
          <layout-main-container-sidebar-opener
            class="md:hidden"
            [isOpen]="isSidebarOpen()"
            (toggled)="toggleSidebar()"
          />
        </div>
        <div class="mx-4 border-b border-solid border-white/20"></div>
      </div>
      <div class="min-h-0 flex-1 overflow-y-auto">
        <nav class="mt-2 px-6">
          @for (item of items(); track item.label) {
            <layout-main-container-sidebar-item [item]="item" />
          }
        </nav>
      </div>
      <div class="my-4 flex flex-col">
        <div class="mx-4 my-4 border-b border-solid border-white/20"></div>
        <a href="https://gisys.se" class="ml-12">
          <img src="assets/GISYS_white_horizontal_RGB_svg.svg" alt="GISYS Logo" class="w-24" />
        </a>
      </div>
    </div>

    @defer (when debugVariables().length > 0) {
      <layout-main-container-sidebar-debug [variables]="debugVariables()" />
    }
  `,
  host: {
    class:
      "bg-sidebar text-sidebar-foreground absolute z-10 flex h-screen w-full flex-col md:fixed md:inset-y-0 md:left-0 md:w-70 md:h-screen md:z-20 md:shadow-lg",
    role: "complementary",
  },
})
export class MainContainerSidebar {
  // Dependencies
  readonly #mainContainerStore = inject(MainContainerStore);

  // Computeds
  readonly isSidebarOpen = this.#mainContainerStore.isSidebarOpen;
  readonly debugVariables = this.#mainContainerStore.debugVariables;
  readonly items = this.#mainContainerStore.items;

  toggleSidebar = () => {
    this.#mainContainerStore.toggleSidebarOpenState();
  };
}
